module.exports = __webpack_public_path__ + "img/img27.3d6f28d3.svg";